import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { SystemSettingResponse } from '@/repositories/generated';

const response: SystemSettingResponse = {
  splitUseFlg: false,
  useGiftFlg: true,
  duplicateCheckFlag: true,
  firstBonusPeriodMonths: [4, 5, 6, 7, 8],
  secondBonusPeriodMonths: [10, 11, 12, 1, 2],
};

export const systemSetting = http.get(
  createMockEndpoint('/system_setting'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
